// extracted by mini-css-extract-plugin
module.exports = {"textarea":"CustomTextarea_textarea_1W7VK","secondary":"CustomTextarea_secondary_1mTWx","textarea_error":"CustomTextarea_textarea_error_JwxEZ"};